<template>
  <div class="skill__content">
    <p>
      Responsive websites using traditional markup and/or modern FrontEnd
      frameworks.
    </p>
  </div>
</template>
